import { render } from "./RelatedProducts.vue?vue&type=template&id=df5079e2&scoped=true"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"

import "./RelatedProducts.vue?vue&type=style&index=0&id=df5079e2&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5079e2"]])

export default __exports__